import { render, staticRenderFns } from "./MatriculasAeePorUnidade.vue?vue&type=template&id=58bf2459&scoped=true"
import script from "./MatriculasAeePorUnidade.vue?vue&type=script&lang=js"
export * from "./MatriculasAeePorUnidade.vue?vue&type=script&lang=js"
import style0 from "./MatriculasAeePorUnidade.vue?vue&type=style&index=0&id=58bf2459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf2459",
  null
  
)

export default component.exports